export default __webpack_public_path__ + "static/media/Rachel_Binder-Hathaway_AHV_In_Moms_We_Trust.7d41a1d2.jpg";